import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeDoor"><Path d="M21 8.64489L12 1.28125L3 8.64489V21.0003H8V12H16V21.0003H21V8.64489Z" fill="currentColor"/><Path d="M14.5 21.0003V13.5H9.5V21.0003H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeDoor;
